module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Checkmark_unselect_Light Blue.00ca0cbe.svg";